import { ServiceState } from '../interfaces/serviceDashboard'
import { Types, types } from '../types'
import { ServiceActions } from '../types/serviceDashboard/actionTypes'








const initialState: ServiceState = {
    getSecretaryPending: false,
    getSecretarySuccess: false,
    getSecretaryError: '',
    secretaryInfo: null,

    getIvrPending: false,
    getIvrSuccess: false,
    getIvrError: '',
    ivrInfo: null,


    getFaxPending: false,
    getFaxSuccess: false,
    getFaxError: '',
    faxInfo: null,


    getDashboardPending: false,
    getDashboardSuccess: false,
    getDashboardError: '',
    dashboardInfo: null,


    freeSecretaryPending: false,
    freeSecretarySuccess: false,
    freeSecretaryError: '',
    freeSecretaryInfo: null,

    freeIVRPending: false,
    freeIVRSuccess: false,
    freeIVRError: '',
    freeIVRInfo: null,

    getCreditDetailsPending: false,
    getCreditDetailsSuccess: false,
    getCreditDetailsError: '',
    data: {},

}


const servicesReducer = (state = initialState, action: ServiceActions) => {
    switch (action.type) {
        case Types.GET_SECRETARY_INFO_SERVICE_REQUEST:
            return {
                ...state,
                getSecretaryPending: true,
                getSecretarySuccess: false,
                getSecretaryError: '',
                secretaryInfo: null,
            }
        case Types.GET_SECRETARY_INFO_SERVICE_SUCCESS:
            return {
                ...state,
                getSecretaryPending: false,
                getSecretarySuccess: true,
                getSecretaryError: '',
                secretaryInfo: action.payload.params,
            }
        case Types.GET_SECRETARY_INFO_SERVICE_ERROR:
            return {
                ...state,
                getSecretaryPending: false,
                getSecretarySuccess: false,
                getSecretaryError: action.payload,
                secretaryInfo: null,
            }

        //IVR**************************************************/
        case Types.GET_IVR_INFO_SERVICE_REQUEST:
            return {
                ...state,
                getIvrPending: true,
                getIvrSuccess: false,
                getIvrError: '',
                ivrInfo: null,
            }
        case Types.GET_IVR_INFO_SERVICE_SUCCESS:
            return {
                ...state,
                getIvrPending: false,
                getIvrSuccess: true,
                getIvrError: '',
                ivrInfo: action.payload.params,
            }
        case Types.GET_IVR_INFO_SERVICE_ERROR:
            return {
                ...state,
                getIvrPending: false,
                getIvrSuccess: false,
                getIvrError: action.payload,
                ivrInfo: null,
            }
        //FAX**************************************************
        case Types.GET_FAX_INFO_SERVICE_REQUEST:
            return {
                ...state,
                getFaxPending: true,
                getFaxSuccess: false,
                getFaxError: '',
                faxInfo: null,
            }
        case Types.GET_FAX_INFO_SERVICE_SUCCESS:
            return {
                ...state,
                getFaxPending: false,
                getFaxSuccess: true,
                getFaxError: '',
                faxInfo: action.payload.params,
            }
        case Types.GET_FAX_INFO_SERVICE_ERROR:
            return {
                ...state,
                getFaxPending: false,
                getFaxSuccess: false,
                getFaxError: action.payload,
                faxInfo: null,
            }
        //dashboard******************************************
        case Types.GET_DASHBOARD_DATA_REQUEST:
            return {
                ...state,
                getDashboardPending: true,
                getDashboardSuccess: false,
                getDashboardError: '',
                dashboardInfo: null,
            }
        case Types.GET_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                getDashboardPending: false,
                getDashboardSuccess: true,
                getDashboardError: '',
                dashboardInfo: action.payload.params,
            }
        case Types.GET_DASHBOARD_DATA_ERROR:
            return {
                ...state,
                getDashboardPending: false,
                getDashboardSuccess: false,
                getDashboardError: action.payload,
                dashboardInfo: null,
            }
        case Types.GET_DASHBOARD_DATA_RESET_PROPS:
            return {
                ...state,
                getDashboardPending: false,
                getDashboardSuccess: false,
                getDashboardError: null,
            }
        ////free secretary***************************************************************************
        case Types.GET_FREE_SECRETARY_PACKAGE_REQUEST:
            return {
                ...state,
                freeSecretaryPending: true,
                freeSecretarySuccess: false,
                freeSecretaryError: '',
                freeSecretaryInfo: null
            }
        case Types.GET_FREE_SECRETARY_PACKAGE_SUCCESS:
            return {
                ...state,
                freeSecretaryPending: false,
                freeSecretarySuccess: true,
                freeSecretaryError: '',
                freeSecretaryInfo: action.payload.params
            }
        case Types.GET_FREE_SECRETARY_PACKAGE_ERROR:
            return {
                ...state,
                freeSecretaryPending: false,
                freeSecretarySuccess: false,
                freeSecretaryError: action.payload,
                freeSecretaryInfo: null
            }
        //free ivr********************************************************************************************** */
        case Types.GET_FREE_IVR_PACKAGE_REQUEST:
            return {
                ...state,
                freeIVRPending: false,
                freeIVRSuccess: false,
                freeIVRError: '',
                freeIVRInfo: ''
            }
        case Types.GET_FREE_IVR_PACKAGE_SUCCESS:
            return {
                ...state,
                freeIVRPending: false,
                freeIVRSuccess: true,
                freeIVRError: '',
                freeIVRInfo: action.payload.params
            }
        case Types.GET_FREE_IVR_PACKAGE_ERROR:
            return {
                ...state,
                freeIVRPending: false,
                freeIVRSuccess: true,
                freeIVRError: action.payload,
                freeIVRInfo: ''
            }
        case Types.GET_CREDIT_DETAILS_REQUEST:
            return {
                ...state,
                getCreditDetailsPending: true,
                getCreditDetailsSuccess: false,
                getCreditDetailsError: '',
                data: {},
            }
        //reset free
        case Types.RESET_FREE_SERVICE:
            return {
                ...state,
                freeIVRPending: false,
                freeIVRSuccess: false,
                freeIVRError: '',
                freeIVRInfo: null,
                freeSecretaryPending: false,
                freeSecretarySuccess: false,
                freeSecretaryError: null,
                freeSecretaryInfo: null
            }
        case Types.GET_CREDIT_DETAILS_SUCCESS:
            return {
                ...state,
                getCreditDetailsPending: false,
                getCreditDetailsSuccess: true,
                getCreditDetailsError: '',
                data: action.payload.params,
            }

        case Types.GET_CREDIT_DETAILS_ERROR:
            return {
                ...state,
                getCreditDetailsPending: false,
                getCreditDetailsSuccess: false,
                getCreditDetailsError: action.payload,
                data: {},
            }

      

        default:
            return {
                ...state
            }

    }
}

export default servicesReducer
